"use client";

import type { AddonDietAddonsRead } from "@repo/api/catalog/api/schemas/addon-diet-addons-read";
import { useCallback } from "react";
import {
  ADDON_ITEM_VARIANT,
  buildAddonGtmListItem,
  slugifyAddonCategoryName,
} from "@/features/addons/lib/addon-gtm-item";
import { sendEvent } from "../gtm/event";
import type { AddonListType } from "./use-addon-view-item-list-event";

type ReportSelectedAddonParams = {
  addon: AddonDietAddonsRead;
  listType: AddonListType;
  categoryName?: string;
  cateringName?: string;
  index: number;
};

export const useAddonSelectItemEvent = () =>
  useCallback(
    ({
      addon,
      listType,
      categoryName,
      cateringName,
      index,
    }: ReportSelectedAddonParams) => {
      if (!categoryName) {
        return;
      }

      sendEvent({
        event: "select_item",
        data: {
          item_list_name: `${listType}-${slugifyAddonCategoryName(categoryName)}`,
          items: [
            {
              ...buildAddonGtmListItem({ addon, cateringName, index }),
              item_variant: ADDON_ITEM_VARIANT,
            },
          ],
        },
      });
    },
    [],
  );
